import { useContext } from 'react';

import PageCountProvider from './PageCountProvider';

export default function usePageCount() {
  return useContext(PageCountProvider.Context);
}
